export default import.meta.ROLLUP_FILE_URL_JustV4LBU_qC5yBE8L2cBg